/**
 * FileInputButton - View component for file/camera input button
 * Pure presentation component with no business logic
 */

import React from 'react';
import CameraIcon from './icons/CameraIcon';

export default function FileInputButton({ onChange }) {
  return (
    <>
      <input
        id="file-input"
        type="file"
        accept="image/*"
        capture="environment"
        onChange={onChange}
        style={{ display: 'none' }}
      />
      <label htmlFor="file-input" className="icon-button" title="Upload or use camera">
        <CameraIcon />
      </label>
    </>
  );
}
